import React from "react";
import {Modal} from "antd";
import {CustomerOrderDetail} from "components/customer/customerOrderDetailPage/customerOrderDetail/CustomerOrderDetail";
import styled from "styled-components";

const StyledModal = styled(Modal)`
    @media (max-width: 768px) {
        max-width: 100% !important;
        width: 100% !important;
        margin: 0 !important;
        top: 0 !important;
        padding-bottom: 0;

        .ant-modal-content {
            border-radius: 0;
            height: 100vh;
            display: flex;
            flex-direction: column;
            max-width: 100vw;
            overflow: hidden;
        }

        .ant-modal-header {
            border-radius: 0;
            padding: 12px 16px;
            flex-shrink: 0;
        }

        .ant-modal-body {
            flex: 1;
            overflow-y: auto;
            overflow-x: hidden;
            padding: 12px;
            max-width: 100vw;
            box-sizing: border-box;

            > div {
                max-width: 100%;
                overflow-x: hidden;
            }
        }

        .ant-modal-close {
            top: 8px;
            right: 8px;
        }

        .ant-modal-close-x {
            width: 48px;
            height: 48px;
            line-height: 48px;
            font-size: 20px;
        }

        /* Better button spacing on mobile */
        .ant-btn {
            font-size: 13px;
            padding: 6px 12px;
            height: auto;
        }

        /* Better row spacing */
        .ant-row {
            margin-left: 0 !important;
            margin-right: 0 !important;
        }
    }
`;

export const CustomerOrderDetailModal = ({visible, onCancel, onOk, deliveryId}) => {
    return (
        <StyledModal
            visible={visible}
            onCancel={onCancel}
            width="85%"
            footer={null}
            className="customer-order-detail-modal"
            style={{
                maxHeight: "90vh",
                top: "5vh"
            }}
            bodyStyle={{
                maxHeight: "calc(90vh - 10px)",
                overflow: "auto"
            }}
        >
            <div>
                <CustomerOrderDetail key={deliveryId} deliveryId={deliveryId} />
            </div>
        </StyledModal>
    );
};
